





























































import { Component, Vue, Watch } from "vue-property-decorator";
import NavBar from "./components/NavBar.vue";
import AsideMenu from "./components/AsideMenu.vue";
import FooterBar from "./components/FooterBar.vue";
import Overlay from "./components/Overlay.vue";
import AsideRight from "./components/AsideRight.vue";
import { AppModule } from "./store/modules/app";
import { UserModule } from "./store/modules/user";

@Component({
  name: "home",
  components: {
    AsideRight,
    Overlay,
    FooterBar,
    AsideMenu,
    NavBar,
  },
})
export default class extends Vue {
  private menuSecondary: any = null;
  private menuSecondaryLabel: string | null = null;
  private menuSecondaryIcon: string | null = null;

  get isOverlayVisible() {
    return true;
  }

  get initialized() {
    return AppModule.initialized;
  }

  get initializationError() {
    return AppModule.initializationError;
  }

  get menu() {
    return [
      "General",
      [
        {
          to: "/",
          icon: "desktop-mac",
          label: "Dashboard",
        },
      ],
      "Settings",
      [
        {
          to: "/settings/tokens",
          icon: "key",
          label: "Access Tokens",
        },
        {
          to: "/settings/apps",
          icon: "apps",
          label: "Third-Party Apps",
        },
      ],
      // "Admin",
      // [
      //   {
      //     to: "/admin/users",
      //     icon: "account-group",
      //     label: "User Management",
      //   },
      // ]
    ];
  }

  get menuBottom() {
    return [
      {
        action: "logout",
        icon: "logout",
        label: "Log out",
        state: "info",
      },
    ];
  }

  private async menuClick(item: any) {
    if (item.menuSecondary) {
      this.menuSecondary = item.menuSecondary;
      this.menuSecondaryLabel = item.menuSecondaryLabel
        ? item.menuSecondaryLabel
        : null;
      this.menuSecondaryIcon = item.menuSecondaryIcon
        ? item.menuSecondaryIcon
        : null;

      this.$store.commit("asideActiveForcedKeyToggle", item);
      this.$store.commit("overlayToggle", true);
    } else if (item.action && item.action === "logout") {
      await UserModule.LogOut();
      this.$router.push(`/login?next=${this.$route.fullPath}`);
    }
  }

  private menuSecondaryCloseClick() {
    this.$store.commit("overlayToggle", false);
  }

  private menuSecondaryClose() {
    this.menuSecondary = this.menuSecondaryLabel = this.menuSecondaryIcon = null;
    this.$store.commit("asideActiveForcedKeyToggle", null);
  }

  @Watch("isOverlayVisible")
  private onIsOverlayVisibleChange(newValue: boolean) {
    if (!newValue) {
      this.menuSecondaryClose();
    }
  }

  mounted() {
    this.$store.dispatch("SetFullPageMode", true);
    this.$store.dispatch("ToggleRightSideBar", false);
    AppModule.Initialize();
  }

  @Watch("initialized")
  onInitializedChanged(value: boolean, oldValue: boolean) {
    if (value) {
      this.$store.dispatch("SetFullPageMode", false);
      this.$store.dispatch("ToggleSideBar", AppModule.isAsideExpanded);
      this.$store.dispatch(
        "ToggleMobileSideBar",
        AppModule.isAsideMobileExpanded
      );
    }
  }
}
